Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = placeholderStyle;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var selectors = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-moz-placeholder', ':-ms-input-placeholder', '::placeholder'];

var validProperties = new Set(['font', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontFamily', 'color', 'background', 'backgroundImage', 'backgroundPosition', 'backgroundSize', 'backgroundRepeat', 'backgroundOrigin', 'backgroundClip', 'backgroundAttachment', 'backgroundColor', 'wordSpacing', 'letterSpacing', 'textDecoration', 'verticalAlign', 'textTransform', 'lineHeight', 'textIndent', 'opacity']);

function placeholderStyle(styles) {
  if (!styles) return null;

  Object.keys(styles).forEach(function (prop) {
    if (!validProperties.has(prop)) {
      throw new Error('\u201C' + String(prop) + '\u201D is not a valid property for the ::placeholder psuedo element.');
    }
  });

  return selectors.reduce(function (accumulatedStyles, selector) {
    return Object.assign({}, accumulatedStyles, _defineProperty({}, selector, styles));
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/placeholderStyle.js
// module id = 445
// module chunks = 923280921217